import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';

export interface Props {
  productLicensePublicName: string;
  activationsRemaining: number;
}

function PreviouslyAllocated({ activationsRemaining, productLicensePublicName }: Props) {
  return (
    <>
      <T
        kind="There is <span>{{count}} license activation</span> remaining for {{name}}."
        span={(content) => <span className="font-bold">{content}</span>}
        count={activationsRemaining}
        name={productLicensePublicName}
      />{' '}
      <T kind="Some invited participants already have a license." />
    </>
  );
}

export default observer(PreviouslyAllocated);
